import "core-js/modules/es.array.reduce.js";
export function getAttributeValueByPath(record, path) {
  return path.reduce(function (current, key) {
    return current && current[key];
  }, record);
}